import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import GoogleCalendarPannel from './pages/appointments/googleCalendarPannel';
import DashBoard from './pages/appointments/dashBoard.js';
import JobAdderPanel from './pages/jobadder/jobAdderPanel.js';
import HotelBookingPage from './pages/hotelBooking/booking.js';
import { useLocation } from 'react-router-dom';
import { getAccountFromUrl } from './utils/appointments/urlUtils';
import Login from './pages/appointments/loginPage.js';
import GoogleAuthMiddleware from './pages/appointments/googleAuthMiddleware.js';
import ContextProvider from './ContextProvider';
import SettingsPage from './pages/appointments/setting';
import AuthGuard from './components/appointments/authGuard';
import Unauthorized from './pages/appointments/unAuthorizedPage';
import ApplicationDashboard from './pages/applicationDashboard.js';

import CreateContactPage from './pages/createContactPage';

import axios from 'axios';

// Global axios interceptor for 401 handling
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Wrapper to provide acctNo from query to HotelBookingPage
function HotelBookingPanelWrapper() {
  const location = useLocation();
  const acctNo = getAccountFromUrl(location.search);
  return <HotelBookingPage acctNo={acctNo} />;
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));

  // Listen to token changes
  useEffect(() => {
    const checkToken = () => {
      setIsAuthenticated(!!localStorage.getItem('token'));
    };

    // Custom event when token is changed manually
    window.addEventListener('authChange', checkToken);

    // Also watch cross-tab changes
    window.addEventListener('storage', checkToken);

    return () => {
      window.removeEventListener('authChange', checkToken);
      window.removeEventListener('storage', checkToken);
    };
  }, []);

  // Top-level JobAdderPanelWrapper for /jobadder
  // Wrapper to provide acctNo and acctId from Dashboard context to JobAdderPanel
  function JobAdderPanelWrapper() {
    const location = useLocation();
    const acctNo = getAccountFromUrl(location.search);
    return <JobAdderPanel acctNo={acctNo} />;
  }

  return (
    <ContextProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Create Contact page, no auth, no sidebar, Botamation logo at top */}
          <Route path="/create-contact" element={<CreateContactPage />} />
          <Route path="/google-middleware" element={<GoogleAuthMiddleware />} />
          {/* Public routes */}
          {/* This path will catch queries with acctNo parameter */}
          <Route
            path="/login"
            element={
              isAuthenticated ? (
                <Navigate to="/appointments" replace />
              ) : (
                <Login />
              )
            }
          />

          <Route
            path="/appointments"
            element={
              <AuthGuard>
                <DashBoard />
              </AuthGuard>
            }
          >
            {/* Default (index) route shows Google Calendar */}

            <Route index element={<GoogleCalendarPannel />} />
            {/* Hotel Booking Page route */}
            {/* Job Adder Panel route */}
            {/* Top-level /jobadder route, dashboard-wrapped, accepts ?acc=... */}
            {/* Settings nested routes */}
            <Route
              path="settings"
              element={

                <SettingsPage />

              }
            />
            <Route
              path="settings/users"
              element={

                <SettingsPage />

              }
            />
            <Route
              path="settings/setup"
              element={

                <SettingsPage />

              }
            />
            <Route
              path="settings/categories"
              element={

                <SettingsPage />

              }
            />
            <Route
              path="settings/delete"
              element={

                <SettingsPage />

              }
            />
          </Route>
          <Route
            path="/jobadder"
            element={
              <AuthGuard>
                <DashBoard />
              </AuthGuard>
            }
          >
            <Route index element={<JobAdderPanelWrapper />} />
          </Route>

          <Route
            path="/hotelBooking"
            element={
              <AuthGuard>
                <DashBoard />
              </AuthGuard>
            }
          >
            <Route index element={<HotelBookingPanelWrapper />} />
          </Route>

          {/* Dashboard route */}
          <Route
            path="/dashboard"
            element={
              <ApplicationDashboard />
            }
          />
          {/* Unauthorized route */}
          <Route
            path="/appointments/unauthorized"
            element={
              <AuthGuard>
                <Unauthorized />
              </AuthGuard>
            }
          />          {/* Remove or update these routes as they're not needed or should be redirects */}
          <Route path="/settings" element={<Navigate to="/appointments/settings" replace />} />
          <Route path="/settings/users" element={<Navigate to="/appointments/settings/users" replace />} />
          <Route path="/settings/setup" element={<Navigate to="/appointments/settings/setup" replace />} />
          <Route path="/settings/categories" element={<Navigate to="/appointments/settings/categories" replace />} />
          <Route path="/settings/delete" element={<Navigate to="/appointments/settings/delete" replace />} />

          {/* Default redirect based on auth status */}
          <Route
            path="/"
            element={
              isAuthenticated ? (
                <Navigate to="/appointments" replace />
              ) : (
                <Navigate to="/login" replace />
              )
            }

          />
          <Route
            path="*"
            element={
              isAuthenticated ? (
                <Navigate to="/appointments" replace />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
        </Routes>
      </BrowserRouter>
    </ContextProvider>
  );
}

export default App;